export enum MutationTypes {
  SET_PROJECTS = "SET_BOOKS",
  SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT",
  SET_CURRENT_PACKAGE = "SET_CURRENT_PACKAGE",
  ADD_AND_SET_CURRENT_PROJECT = "ADD_AND_SET_CURRENT_PROJECT",
  ADD_AND_SET_CURRENT_PACKAGE = "ADD_AND_SET_CURRENT_PACKAGE",
  ADD_PROJECT_TAG = "ADD_PROJECT_TAG",
  UPDATE_PROJECT = "UPDATE_PROJECT",
}
